import React from "react";
import { CustomLabel } from "../../Constant";
import CustomStepper from "../../elements/CustomStepper";

const SarvahStepper = ({ label, ...props }) => {
  return (
    <div className="d-flex align-items-center mt-1">
      <div className={label === 'Kids' ? 'pe-3 pe-sm-1' : 'pe-1'}>
        <CustomLabel font_size='12'>{label}</CustomLabel>
      </div>
      <div className="pe-1">
        <CustomStepper {...props}/>
      </div>
    </div>
  );
};

export default SarvahStepper;
